import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { PageShell } from '../../components/layout/PageShell'

// Public privacy policy — used as the Privacy Policy URL for Facebook/Google and the app stores.
// NOTE: the registered-company details and any legal review are the operator's responsibility.
export function PrivacyPage() {
  const { t } = useTranslation()
  const { locale: routeLocale = 'it' } = useParams()
  return (
    <PageShell>
      <div className="mb-6">
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-ink-900 sm:text-3xl">{t('legal.privacyTitle')}</h1>
        <p className="mt-1.5 text-sm text-ink-500">{t('legal.privacySubtitle')}</p>
      </div>

      <div className="space-y-6 rounded-2xl bg-white p-5 text-sm leading-relaxed text-ink-600 shadow-card ring-1 ring-ink-100 sm:p-7">
        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.privacyControllerTitle')}</h2>
          <p className="mt-1.5">
            {t('legal.privacyControllerBodyPre')}{' '}
            <a href="mailto:privacy@garagesanmarco.it" className="text-brand-600 underline">privacy@garagesanmarco.it</a>.
          </p>
        </section>

        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.privacyDataTitle')}</h2>
          <ul className="mt-1.5 list-disc space-y-1 pl-5">
            <li>{t('legal.privacyData1')}</li>
            <li>{t('legal.privacyData2')}</li>
            <li>{t('legal.privacyData3')}</li>
            <li>{t('legal.privacyData4')}</li>
            <li>{t('legal.privacyData5')}</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.privacyPurposeTitle')}</h2>
          <p className="mt-1.5">
            {t('legal.privacyPurposeBody')}
          </p>
        </section>

        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.privacyThirdPartyTitle')}</h2>
          <p className="mt-1.5">
            {t('legal.privacyThirdPartyBody')}
          </p>
        </section>

        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.privacyRetentionTitle')}</h2>
          <p className="mt-1.5">
            {t('legal.privacyRetentionBody')}
          </p>
        </section>

        <section>
          <h2 className="font-display text-base font-bold text-ink-900">{t('legal.privacyRightsTitle')}</h2>
          <p className="mt-1.5">
            {t('legal.privacyRightsBodyPre')}{' '}
            <Link to={`/${routeLocale}/data-deletion`} className="text-brand-600 underline">{t('legal.privacyRightsLink')}</Link>{t('legal.privacyRightsBodyPost')}{' '}
            <a href="mailto:privacy@garagesanmarco.it" className="text-brand-600 underline">privacy@garagesanmarco.it</a>.
          </p>
        </section>
      </div>

      <Link
        to={`/${routeLocale}`}
        className="mt-7 inline-flex h-11 items-center gap-2 rounded-xl border border-ink-200 px-5 text-sm font-semibold text-ink-700 hover:bg-ink-50"
      >
        <ArrowLeft className="h-4 w-4" /> {t('common.backHome')}
      </Link>
    </PageShell>
  )
}
